/** Fallback when `ezyhub/mobile_shell` has no `props.slides` on the `promo_carousel` block. */
export type PromoSlideAction =
	| "open-category"
	| "open-troca-via-hub"
	| "open-app-download";
export type PromoSlidePlatform = "web" | "ios" | "android";

export interface PromoCarouselSlideConfig {
	id: string;
	title: string;
	subtitle: string;
	category: string;
	category_id: string;
	imageUrl: string;
	backgroundColor: string;
	/**
	 * Optional CSS `background` value (a `#hex` color or a `linear-gradient(...)` of `#hex` stops),
	 * applied inline over `backgroundColor`. Lets config use brand colors that are not compiled
	 * Tailwind classes; older clients ignore it and keep the `backgroundColor` class.
	 */
	backgroundStyle?: string;
	action?: PromoSlideAction;
	ctaLabel?: string;
	/**
	 * Optional allow-list of runtime platforms on which this slide is shown. When omitted or empty,
	 * the slide appears on every platform. Used, e.g., to hide the "Baixe nosso aplicativo" slide on
	 * iOS/Android (user is already in the app) while keeping it on the web.
	 */
	platforms?: PromoSlidePlatform[];
}

export const DEFAULT_PROMO_SLIDES: PromoCarouselSlideConfig[] = [
	{
		id: "troca-via-hub",
		title: "Trocas com mais segurança",
		subtitle:
			"Entenda como funciona o envio pelo Hub akihub em negociações com dois ou mais produtos",
		category: "Troca via Hub",
    category_id: "",
    imageUrl:
      "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080",
    backgroundColor: "bg-gradient-to-r from-teal-600 to-cyan-700",
    action: "open-troca-via-hub",
    ctaLabel: "Como funciona",
	},
	{
		id: "1",
		title: "Ofertas de Eletrônicos",
		subtitle: "Economize até 50% em eletrônicos",
		category: "Eletrônicos",
		category_id: "Eletrônicos",
		imageUrl:
			"https://images.unsplash.com/photo-1571857089849-f6390447191a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxlbGVjdHJvbmljcyUyMHN0b3JlfGVufDF8fHx8MTc2ODY1NjkxM3ww&ixlib=rb-4.1.0&q=80&w=1080",
		backgroundColor: "bg-gradient-to-r from-blue-500 to-cyan-500",
	},
	{
		id: "2",
		title: "Promoção de Móveis",
		subtitle: "Móveis de qualidade com ótimos preços",
		category: "Móveis",
		category_id: "Móveis",
		imageUrl:
			"https://images.unsplash.com/photo-1623514814234-d03651636c21?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxmdXJuaXR1cmUlMjBpbnRlcmlvcnxlbnwxfHx8fDE3Njg3NTY1MDR8MA&ixlib=rb-4.1.0&q=80&w=1080",
		backgroundColor: "bg-gradient-to-r from-sky-500 to-blue-500",
	},
	{
		id: "3",
		title: "Esportes & Fitness",
		subtitle: "Fique ativo com equipamentos incríveis",
		category: "Esportes",
		category_id: "Esportes",
		imageUrl:
			"https://images.unsplash.com/photo-1602211844066-d3bb556e983b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzcG9ydHMlMjBlcXVpcG1lbnR8ZW58MXx8fHwxNzY4NzA4MTY0fDA&ixlib=rb-4.1.0&q=80&w=1080",
		backgroundColor: "bg-gradient-to-r from-blue-600 to-sky-600",
	},
	{
		id: "4",
		title: "Roupas & Moda",
		subtitle: "Renove seu guarda-roupa",
		category: "Vestuário",
		category_id: "cat_b3b7deacf52f",
		imageUrl:
			"https://images.unsplash.com/photo-1441986300917-64674bd600d8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjbG90aGluZyUyMHN0b3JlfGVufDF8fHx8MTc2ODc4NTQwMHww&ixlib=rb-4.1.0&q=80&w=1080",
		backgroundColor: "bg-gradient-to-r from-cyan-600 to-blue-600",
	},
	{
		id: "5",
		title: "Veículos Usados",
		subtitle: "Encontre o carro dos sonhos",
		category: "Veículos",
		category_id: "Veículos",
		imageUrl:
			"https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjYXIlMjB2ZWhpY2xlfGVufDF8fHx8MTc2ODc4NTQwMHww&ixlib=rb-4.1.0&q=80&w=1080",
		backgroundColor: "bg-gradient-to-r from-blue-700 to-cyan-700",
	},
	{
		id: "musical-instruments",
		title: "Instrumentos Musicais",
		subtitle: "Sua paixão pela música começa aqui",
		category: "Instrumentos Musicais",
		category_id: "cat_21d5fca52759",
		imageUrl:
			"https://images.unsplash.com/photo-1685603084426-2fdb03be0931?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtdXNpY2FsJTIwaW5zdHJ1bWVudHMlMjBndWl0YXIlMjBwaWFub3xlbnwxfHx8fDE3NzM4NjY2NjF8MA&ixlib=rb-4.1.0&q=80&w=1080",
		backgroundColor: "bg-gradient-to-r from-purple-600 to-pink-600",
	},
	{
		id: "toys-hobbies",
		title: "Brinquedos e Hobbies",
		subtitle: "Diversão para todas as idades",
		category: "Brinquedos e Hobbies",
		category_id: "cat_b1b9b00e0639",
		imageUrl:
			"https://images.unsplash.com/photo-1772920909185-05b854e3858f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx0b3lzJTIwaG9iYmllcyUyMGNoaWxkcmVuJTIwcGxheWluZ3xlbnwxfHx8fDE3NzM4NjY2NjF8MA&ixlib=rb-4.1.0&q=80&w=1080",
		backgroundColor: "bg-gradient-to-r from-orange-500 to-red-500",
	},
	{
		id: "cosmetics",
		title: "Cosméticos & Beleza",
		subtitle: "Produtos de beleza com ótimos preços",
		category: "Cosméticos",
		category_id: "cat_537c4308ee71",
		imageUrl:
			"https://images.unsplash.com/photo-1765852549902-bd9c79d01afb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwyfHxjb3NtZXRpY3MlMjBtYWtldXAlMjBza2luY2FyZSUyMHByb2R1Y3RzfGVufDF8fHx8MTc3NTY4MTM1MXww&ixlib=rb-4.1.0&q=80&w=1080",
		backgroundColor: "bg-gradient-to-r from-pink-500 to-rose-500",
	},
];
